import { render, staticRenderFns } from "./LockedComponent.vue?vue&type=template&id=4999684d&"
import script from "./LockedComponent.vue?vue&type=script&lang=js&"
export * from "./LockedComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports